import React, { useEffect } from 'react';

export default function LightboxModal({ images, activeIndex, onClose, onNext, onPrev }) {
  const isOpen = activeIndex !== null && images && images.length > 0;

  useEffect(() => {
    if (!isOpen) return;

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowRight' && onNext) onNext();
      if (e.key === 'ArrowLeft' && onPrev) onPrev();
    };
    window.addEventListener('keydown', handleKeyDown);
    document.body.style.overflow = 'hidden';

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = '';
    };
  }, [isOpen, onClose, onNext, onPrev]);

  if (!isOpen) return null;

  const currentImage = images[activeIndex];

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 backdrop-blur-md transition-all p-4"
      role="dialog"
      aria-modal="true"
      aria-label="Billedvisning i fuld størrelse"
    >
      {/* Close button */}
      <button
        onClick={onClose}
        className="absolute top-4 right-4 z-10 p-3 rounded-full bg-white/10 hover:bg-white/25 text-white transition-colors focus:outline-none focus:ring-2 focus:ring-white"
        aria-label="Luk fuldskærmsvisning"
      >
        <i className="fa-solid fa-xmark text-xl" aria-hidden="true" />
      </button>

      {/* Prev button */}
      {images.length > 1 && (
        <button
          onClick={onPrev}
          className="absolute left-4 top-1/2 -translate-y-1/2 z-10 p-3 rounded-full bg-white/10 hover:bg-white/25 text-white transition-colors focus:outline-none focus:ring-2 focus:ring-white"
          aria-label="Forrige billede"
        >
          <i className="fa-solid fa-chevron-left text-xl" aria-hidden="true" />
        </button>
      )}

      {/* Main Image */}
      <div className="max-w-5xl max-h-[85vh] flex flex-col items-center justify-center select-none">
        <img
          src={currentImage}
          alt={`Billede ${activeIndex + 1} af ${images.length}`}
          className="max-h-[80vh] max-w-full object-contain rounded-xl shadow-2xl transition-all duration-300"
        />
        {images.length > 1 && (
          <div className="mt-3 px-3 py-1 rounded-full bg-black/50 text-white/90 text-xs font-mono">
            {activeIndex + 1} / {images.length}
          </div>
        )}
      </div>

      {/* Next button */}
      {images.length > 1 && (
        <button
          onClick={onNext}
          className="absolute right-4 top-1/2 -translate-y-1/2 z-10 p-3 rounded-full bg-white/10 hover:bg-white/25 text-white transition-colors focus:outline-none focus:ring-2 focus:ring-white"
          aria-label="Næste billede"
        >
          <i className="fa-solid fa-chevron-right text-xl" aria-hidden="true" />
        </button>
      )}
    </div>
  );
}
